import { Box, Divider, SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../ricos-context";
import { useSpoilerPlugin } from "./../../_shared/use-spoiler-plugin";
import {
  ToggleButton,
  UiComponentsProvider,
  useClickOutside
} from "./../../ui-components";
import { useBiNext } from "../../_shared/use-bi-next";
import { useNodeAttrs } from "../../_shared/use-node-attrs";
import { videoModals } from "../constants";
import { SETTINGS_ALLOW_DOWNALOD_TOGGLE, SETTINGS_SPOILER_TOGGLE } from "../dataHooks";
import classes from "../statics/styles/video-settings-scss";
import { VIDEO_TYPE } from "../types";
const SettingsModal = ({ nodeId }) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext) || {};
  const isSpoilerEnabled = useSpoilerPlugin(VIDEO_TYPE);
  const [modalRef, setModalRef] = useState(null);
  const containerRef = useRef(modalRef);
  const { patchPmNodeAttrs, pmNodeAttrs } = useNodeAttrs(nodeId, "VIDEO");
  const logBi = useBiNext();
  useEffect(() => {
    if (modalRef) {
      containerRef.current = modalRef;
    }
  }, [modalRef]);
  useClickOutside({
    containerRef,
    onClickOutside: (_event) => {
      closeModal();
    },
    triggerOn: "pointerdown"
  });
  const closeModal = () => {
    modalService.closeModal(videoModals.settings);
  };
  if (!pmNodeAttrs) {
    console.error("Video settings: node attrs not found");
    return null;
  }
  const isCustomVideo = !!pmNodeAttrs.disableDownload || pmNodeAttrs.video?.src?.id;
  return /* @__PURE__ */ React.createElement(UiComponentsProvider, null, /* @__PURE__ */ React.createElement("div", { tabIndex: -1, className: classNames(classes.modal), ref: setModalRef }, /* @__PURE__ */ React.createElement(
    SidePanel,
    {
      onCloseButtonClick: closeModal,
      skin: "floating",
      width: isMobile ? "100%" : 288,
      height: isMobile ? "100vh" : void 0
    },
    /* @__PURE__ */ React.createElement("div", { "data-drag-handler": "true" }, /* @__PURE__ */ React.createElement(
      SidePanel.Header,
      {
        showDivider: true,
        className: classes.header,
        title: t("VideoPlugin_Settings_Header")
      }
    )),
    /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP4" }, modalRef && isCustomVideo ? /* @__PURE__ */ React.createElement(
      ToggleButton,
      {
        title: t("VideoPlugin_Settings_VideoCanBeDownloaded_Label"),
        checked: !pmNodeAttrs.disableDownload,
        size: "small",
        onChange: () => {
          logBi({ dataHook: SETTINGS_ALLOW_DOWNALOD_TOGGLE });
          patchPmNodeAttrs({ disableDownload: !pmNodeAttrs.disableDownload });
        },
        infoContent: t("VideoPlugin_Settings_VideoCanBeDownloaded_Tooltip"),
        tooltipAppendTo: modalRef,
        dataHook: SETTINGS_ALLOW_DOWNALOD_TOGGLE
      }
    ) : null, isCustomVideo && isSpoilerEnabled ? /* @__PURE__ */ React.createElement(Divider, null) : null, modalRef && isSpoilerEnabled ? /* @__PURE__ */ React.createElement(
      ToggleButton,
      {
        title: t("VideoSettings_Spoiler_Toggle"),
        checked: !!pmNodeAttrs.containerData?.spoiler?.enabled,
        size: "small",
        onChange: () => {
          logBi({ dataHook: SETTINGS_SPOILER_TOGGLE });
          patchPmNodeAttrs({
            containerData: {
              ...pmNodeAttrs.containerData,
              spoiler: {
                ...pmNodeAttrs.containerData?.spoiler,
                enabled: !pmNodeAttrs.containerData?.spoiler?.enabled
              }
            }
          });
        },
        infoContent: t("Spoiler_Toggle_Tooltip"),
        tooltipAppendTo: modalRef,
        dataHook: SETTINGS_SPOILER_TOGGLE
      }
    ) : null)
  )));
};
export {
  SettingsModal
};
//# sourceMappingURL=SettingsModal.js.map
